import axios from '@/plugins/axios'

const getAwards = async ({ type, target, page = 1, awardables = false }) => {
  try {
    const params = {}
    if (type === 'user') params.user_id = target
    else if (type === 'post') params.post_id = target
    else if (type === 'book') params.book_id = target
    if (awardables) params.awardables = 1
    params.page = page
    const response = await axios.get('awards', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  getAwards
}
